import axios from "axios";

const state = {
    loader: true,
    data: [],
    headers: []
};

const getters = {};

const actions = {
    getData({ commit, state }, year) {
        state.loader = true;
    
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/huecos?year=" + year)
            .then(response => {
                const rawData = response.data;
    
                const mesesOrdenados = [
                    "Enero", "Febrero", "Marzo", "Abril",
                    "Mayo", "Junio", "Julio", "Agosto",
                    "Septiembre", "Octubre", "Noviembre", "Diciembre"
                ];
    
                const currentYear = new Date().getFullYear();
                let mesesConDatos = mesesOrdenados;
    
                if (year === currentYear) {
                    const mesActualIndex = new Date().getMonth();
                    const mesesHastaActual = mesesOrdenados.slice(0, mesActualIndex + 1);
    
                    mesesConDatos = mesesHastaActual.filter(mes =>
                        rawData.some(cliente => parseFloat(cliente[mes]) > 0)
                    );
                }
    
                // Arma los headers con duplicado por kg
                const headers = [
                    { text: "Cliente", value: "name" },
                    ...mesesConDatos.flatMap(mes => [
                        { text: mes, value: mes },
                        //{ text: mes + ' (kg)', value: mes + '_kg' }
                    ]),
                    { text: "Total Anual", value: "TotalAnual" },
                    //{ text: "Total (kg)", value: "Total_kg" }
                ];
    
                const items = rawData.map(cliente => {
                    const item = {
                        id: cliente.id,
                        name: cliente.name,
                        TotalAnual: parseFloat(cliente.TotalAnual),
                        Total_kg: parseFloat(cliente.Total_kg)
                    };
                    mesesConDatos.forEach(mes => {
                        item[mes] = parseFloat(cliente[mes]);
                        item[mes + '_kg'] = parseFloat(cliente[mes + '_kg']);
                    });
                    return item;
                });
    
                commit('setData', { items, headers });
            })
            .catch(error => {
                console.error('Error:', error);
            })
            .finally(() => {
                state.loader = false;
            });
    }
    
};

const mutations = {
    setData(state, { items, headers }) {
        state.data = items;
        state.headers = headers;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
